interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export default function Logo({ className = '', size = 'md' }: LogoProps) {
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-14 h-14',
    lg: 'w-20 h-20',
    xl: 'w-28 h-28',
  };

  return (
    <svg
      viewBox="0 0 100 100"
      className={`${sizes[size]} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Circle border */}
      <circle
        cx="50"
        cy="50"
        r="46"
        fill="#f0f9ff"
        stroke="#7dd3fc"
        strokeWidth="3"
      />

      {/* Bridge - taller with visible span */}
      <path
        d="M 8 62 Q 28 38 50 38 Q 72 38 92 62"
        fill="none"
        stroke="#94a3b8"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.4"
      />
      {/* Bridge supports */}
      <line x1="22" y1="45" x2="22" y2="62" stroke="#94a3b8" strokeWidth="1.5" opacity="0.4" />
      <line x1="36" y1="40" x2="36" y2="62" stroke="#94a3b8" strokeWidth="1.5" opacity="0.4" />
      <line x1="50" y1="38" x2="50" y2="62" stroke="#94a3b8" strokeWidth="1.5" opacity="0.4" />
      <line x1="64" y1="40" x2="64" y2="62" stroke="#94a3b8" strokeWidth="1.5" opacity="0.4" />
      <line x1="78" y1="45" x2="78" y2="62" stroke="#94a3b8" strokeWidth="1.5" opacity="0.4" />
      {/* Bridge deck */}
      <line x1="8" y1="62" x2="92" y2="62" stroke="#94a3b8" strokeWidth="2" opacity="0.4" />

      {/* Abstract water - simple waves */}
      <path
        d="M 15 65 Q 25 62 35 65 Q 45 68 55 65 Q 65 62 75 65 Q 85 68 90 65"
        fill="none"
        stroke="#38bdf8"
        strokeWidth="2.5"
        strokeLinecap="round"
        opacity="0.6"
      />
      <path
        d="M 20 72 Q 30 69 40 72 Q 50 75 60 72 Q 70 69 80 72"
        fill="none"
        stroke="#7dd3fc"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.5"
      />

      {/* Sailboat */}
      <g>
        {/* Mast */}
        <line
          x1="50"
          y1="22"
          x2="50"
          y2="58"
          stroke="#0284c7"
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {/* Main sail - curved */}
        <path
          d="M 50 24 Q 72 35 68 53 L 50 53"
          fill="#e0f2fe"
          stroke="#0ea5e9"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* Jib sail - triangle */}
        <path
          d="M 50 28 Q 32 40 35 53 L 50 53"
          fill="#e0f2fe"
          stroke="#0ea5e9"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        {/* SP on the main sail - rendered after sails so it's on top */}
        <text
          x="47"
          y="42"
          fontSize="11"
          fontWeight="bold"
          fontFamily="Arial, sans-serif"
          fill="#0284c7"
        >
          S
        </text>
        <text
          x="54"
          y="36"
          fontSize="11"
          fontWeight="bold"
          fontFamily="Arial, sans-serif"
          fill="#0284c7"
        >
          P
        </text>

        {/* Hull - proper sailboat hull shape */}
        <path
          d="M 30 58
             L 33 62
             Q 50 66 67 62
             L 70 58
             Q 50 61 30 58 Z"
          fill="#0284c7"
          stroke="#0284c7"
          strokeWidth="1"
          strokeLinejoin="round"
        />

        {/* Small flag */}
        <path
          d="M 50 22 L 58 25 L 50 28"
          fill="#f43f5e"
          stroke="#f43f5e"
          strokeWidth="1"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
